export default function Marquee({ items, testid = "marquee" }) {
  return (
    <div className="marquee" data-testid={testid}>
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div className="marquee-group" key={copy} aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={i} className={i % 2 ? "mq outline" : "mq"}>
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
